import showdown from 'showdown';

export function markdownToHtml(markdown: string) {
  const converter = new showdown.Converter({
    tables: true,
  });
  // console.log(converter.makeHtml(markdown));
  return converter.makeHtml(markdown);
}
